import { render, staticRenderFns } from "./catchFace.vue?vue&type=template&id=72e3d576&scoped=true&"
import script from "./catchFace.vue?vue&type=script&lang=js&"
export * from "./catchFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3d576",
  null
  
)

export default component.exports